import * as React from 'react';
import { TechtimePayload, SectionUIProps } from '~/common/types/types';
import { SectionLayout } from '~/components/common/common';
import { TechtimeList } from './components/components';
import * as styles from './techtime.module.scss';

type Props = SectionUIProps & {
  payload: TechtimePayload;
};

const Techtime: React.FC<Props> = ({ payload }) => {
  const {
    title,
    videoLecturesCount,
    projectEnvironmentTitle,
    blocks,
    timeline,
    notice,
    teamCompositionPayload,
  } = payload;

  return (
    <SectionLayout
      headingMessage={title}
      headingLevel="h2"
      classes={{ section: styles.techtime, title: styles.title }}
    >
      <TechtimeList
        blocks={blocks}
        timeline={timeline}
        notice={notice}
        videoLecturesCount={videoLecturesCount}
        projectEnvironmentTitle={projectEnvironmentTitle}
        teamCompositionPayload={teamCompositionPayload}
      />
    </SectionLayout>
  );
};

export { Techtime };
